// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"styles_tableWrap___uO3L"};